export default "__VITE_ASSET__DENMwGJU__"